/** Mirrors backend CorporateApprovalStatus enum (JsonStringEnumConverter). */
export type CorporateApprovalStatus =
  | 'Pending'
  | 'Approved'
  | 'Rejected'
  | 'Suspended';

export const CORPORATE_APPROVAL_STATUS_LABELS: Record<CorporateApprovalStatus, string> = {
  Pending: 'Onay bekliyor',
  Approved: 'Onaylı',
  Rejected: 'Reddedildi',
  Suspended: 'Askıya alındı',
};
